import { Fragment } from 'react';

import {
  BreadcrumbChevron,
  BreadcrumbCurrent,
  BreadcrumbLink,
  BreadcrumbRow,
} from './components';

export type LegalSearchBreadcrumbSegment = {
  label: string;
  /** Omit on the final segment (current page). */
  to?: string;
};

export interface LegalSearchBreadcrumbsProps {
  segments: LegalSearchBreadcrumbSegment[];
  /** @default 'Breadcrumb' */
  'aria-label'?: string;
}

export function LegalSearchBreadcrumbs({
  segments,
  'aria-label': ariaLabel = 'Breadcrumb',
}: LegalSearchBreadcrumbsProps) {
  if (!segments.length) {
    return null;
  }

  return (
    <BreadcrumbRow component="nav" aria-label={ariaLabel}>
      {segments.map((seg, index) => {
        const isLast = index === segments.length - 1;
        return (
          <Fragment key={`${seg.label}-${index}`}>
            {index > 0 && <BreadcrumbChevron aria-hidden />}
            {seg.to && !isLast ? (
              <BreadcrumbLink to={seg.to}>{seg.label}</BreadcrumbLink>
            ) : (
              <BreadcrumbCurrent
                title={seg.label}
                aria-current={isLast ? 'page' : undefined}
              >
                {seg.label}
              </BreadcrumbCurrent>
            )}
          </Fragment>
        );
      })}
    </BreadcrumbRow>
  );
}
